function _createForOfIteratorHelper(o, allowArrayLike) { var it = typeof Symbol !== "undefined" && o[Symbol.iterator] || o["@@iterator"]; if (!it) { if (Array.isArray(o) || (it = _unsupportedIterableToArray(o)) || allowArrayLike && o && typeof o.length === "number") { if (it) o = it; var i = 0; var F = function F() {}; return { s: F, n: function n() { if (i >= o.length) return { done: true }; return { done: false, value: o[i++] }; }, e: function e(_e5) { throw _e5; }, f: F }; } throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); } var normalCompletion = true, didErr = false, err; return { s: function s() { it = it.call(o); }, n: function n() { var step = it.next(); normalCompletion = step.done; return step; }, e: function e(_e6) { didErr = true; err = _e6; }, f: function f() { try { if (!normalCompletion && it.return != null) it.return(); } finally { if (didErr) throw err; } } }; }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var e = -1;
var t = function t(_t) {
    addEventListener("pageshow", function (n) {
      n.persisted && (e = n.timeStamp, _t(n));
    }, !0);
  },
  n = function n(e, t, _n, i) {
    var s, o;
    return function (r) {
      var _s;
      t.value >= 0 && (r || i) && (o = t.value - ((_s = s) !== null && _s !== void 0 ? _s : 0), (o || void 0 === s) && (s = t.value, t.delta = o, t.rating = function (e, t) {
        return e > t[1] ? "poor" : e > t[0] ? "needs-improvement" : "good";
      }(t.value, _n), e(t)));
    };
  },
  i = function i(e) {
    requestAnimationFrame(function () {
      return requestAnimationFrame(function () {
        return e();
      });
    });
  },
  s = function s() {
    var e = performance.getEntriesByType("navigation")[0];
    if (e && e.responseStart > 0 && e.responseStart < performance.now()) return e;
  },
  o = function o() {
    var _e$activationStart;
    var e = s();
    return (_e$activationStart = e === null || e === void 0 ? void 0 : e.activationStart) !== null && _e$activationStart !== void 0 ? _e$activationStart : 0;
  },
  r = function r(t) {
    var n = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : -1;
    var i = s();
    var r = "navigate";
    e >= 0 ? r = "back-forward-cache" : i && (document.prerendering || o() > 0 ? r = "prerender" : document.wasDiscarded ? r = "restore" : i.type && (r = i.type.replace(/_/g, "-")));
    return {
      name: t,
      value: n,
      rating: "good",
      delta: 0,
      entries: [],
      id: "v5-".concat(Date.now(), "-").concat(Math.floor(8999999999999 * Math.random()) + 1e12),
      navigationType: r
    };
  },
  c = new WeakMap();
function a(e, t) {
  return c.get(e) || c.set(e, new t()), c.get(e);
}
var d = /*#__PURE__*/function () {
  function d() {
    _classCallCheck(this, d);
    this.t = void 0;
    this.i = 0;
    this.o = [];
  }
  _createClass(d, [{
    key: "h",
    value: function h(e) {
      var _this$t;
      if (e.hadRecentInput) return;
      var t = this.o[0],
        n = this.o.at(-1);
      this.i && t && n && e.startTime - n.startTime < 1e3 && e.startTime - t.startTime < 5e3 ? (this.i += e.value, this.o.push(e)) : (this.i = e.value, this.o = [e]), (_this$t = this.t) === null || _this$t === void 0 ? void 0 : _this$t.call(this, e);
    }
  }]);
  return d;
}();
var h = function h(e, t) {
    var n = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
    try {
      if (PerformanceObserver.supportedEntryTypes.includes(e)) {
        var _i = new PerformanceObserver(function (e) {
          Promise.resolve().then(function () {
            t(e.getEntries());
          });
        });
        return _i.observe(_objectSpread({
          type: e,
          buffered: !0
        }, n)), _i;
      }
    } catch (_unused) {}
  },
  f = function f(e) {
    var t = !1;
    return function () {
      t || (e(), t = !0);
    };
  };
var u = -1;
var l = new Set(),
  m = function m() {
    return "hidden" !== document.visibilityState || document.prerendering ? 1 / 0 : 0;
  },
  p = function p(e) {
    if ("hidden" === document.visibilityState) {
      if ("visibilitychange" === e.type) {
        var _iterator = _createForOfIteratorHelper(l),
          _step;
        try {
          for (_iterator.s(); !(_step = _iterator.n()).done;) {
            var _e = _step.value;
            _e();
          }
        } catch (err) {
          _iterator.e(err);
        } finally {
          _iterator.f();
        }
      }
      isFinite(u) || (u = "visibilitychange" === e.type ? e.timeStamp : 0, removeEventListener("prerenderingchange", p, !0));
    }
  },
  v = function v() {
    if (u < 0) {
      var _globalThis$performan;
      var _e2 = o(),
        _n2 = document.prerendering ? void 0 : (_globalThis$performan = globalThis.performance.getEntriesByType("visibility-state").filter(function (t) {
          return "hidden" === t.name && t.startTime > _e2;
        })[0]) === null || _globalThis$performan === void 0 ? void 0 : _globalThis$performan.startTime;
      u = _n2 !== null && _n2 !== void 0 ? _n2 : m(), addEventListener("visibilitychange", p, !0), addEventListener("prerenderingchange", p, !0), t(function () {
        setTimeout(function () {
          u = m();
        });
      });
    }
    return {
      get firstHiddenTime() {
        return u;
      },
      onHidden: function onHidden(e) {
        l.add(e);
      }
    };
  },
  g = function g(e) {
    document.prerendering ? addEventListener("prerenderingchange", function () {
      return e();
    }, !0) : e();
  },
  y = [1800, 3e3],
  E = function E(e) {
    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    g(function () {
      var c = v();
      var a,
        d = r("FCP");
      var f = h("paint", function (e) {
        var _iterator2 = _createForOfIteratorHelper(e),
          _step2;
        try {
          for (_iterator2.s(); !(_step2 = _iterator2.n()).done;) {
            var _t2 = _step2.value;
            "first-contentful-paint" === _t2.name && (f.disconnect(), _t2.startTime < c.firstHiddenTime && (d.value = Math.max(_t2.startTime - o(), 0), d.entries.push(_t2), a(!0)));
          }
        } catch (err) {
          _iterator2.e(err);
        } finally {
          _iterator2.f();
        }
      });
      f && (a = n(e, d, y, s.reportAllChanges), t(function (t) {
        d = r("FCP"), a = n(e, d, y, s.reportAllChanges), i(function () {
          d.value = performance.now() - t.timeStamp, a(!0);
        });
      }));
    });
  },
  b = [.1, .25],
  L = function L(e) {
    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var o = v();
    E(f(function () {
      var c,
        f = r("CLS", 0);
      var u = a(s, d),
        l = function l(e) {
          var _iterator3 = _createForOfIteratorHelper(e),
            _step3;
          try {
            for (_iterator3.s(); !(_step3 = _iterator3.n()).done;) {
              var _t3 = _step3.value;
              u.h(_t3);
            }
          } catch (err) {
            _iterator3.e(err);
          } finally {
            _iterator3.f();
          }
          u.i > f.value && (f.value = u.i, f.entries = u.o, c());
        },
        m = h("layout-shift", l);
      m && (c = n(e, f, b, s.reportAllChanges), o.onHidden(function () {
        l(m.takeRecords()), c(!0);
      }), t(function () {
        u.i = 0, f = r("CLS", 0), c = n(e, f, b, s.reportAllChanges), i(function () {
          return c();
        });
      }), setTimeout(c));
    }));
  };
var P = 0,
  T = 1 / 0,
  _ = 0;
var M = function M(e) {
  var _iterator4 = _createForOfIteratorHelper(e),
    _step4;
  try {
    for (_iterator4.s(); !(_step4 = _iterator4.n()).done;) {
      var _t4 = _step4.value;
      _t4.interactionId && (T = Math.min(T, _t4.interactionId), _ = Math.max(_, _t4.interactionId), P = _ ? (_ - T) / 7 + 1 : 0);
    }
  } catch (err) {
    _iterator4.e(err);
  } finally {
    _iterator4.f();
  }
};
var w;
var C = function C() {
    var _performance$interact;
    return w ? P : (_performance$interact = performance.interactionCount) !== null && _performance$interact !== void 0 ? _performance$interact : 0;
  },
  I = function I() {
    "interactionCount" in performance || w || (w = h("event", M, {
      type: "event",
      buffered: !0,
      durationThreshold: 0
    }));
  };
var F = 0;
var k = /*#__PURE__*/function () {
  function k() {
    _classCallCheck(this, k);
    this.u = [];
    this.l = new Map();
    this.m = void 0;
    this.p = void 0;
  }
  _createClass(k, [{
    key: "v",
    value: function v() {
      F = C(), this.u.length = 0, this.l.clear();
    }
  }, {
    key: "L",
    value: function L() {
      var e = Math.min(this.u.length - 1, Math.floor((C() - F) / 50));
      return this.u[e];
    }
  }, {
    key: "h",
    value: function h(e) {
      var _this$m;
      if ((_this$m = this.m) !== null && _this$m !== void 0 && _this$m.call(this, e), !e.interactionId && "first-input" !== e.entryType) return;
      var t = this.u.at(-1);
      var n = this.l.get(e.interactionId);
      if (n || this.u.length < 10 || e.duration > t.P) {
        var _this$p;
        if (n ? e.duration > n.P ? (n.entries = [e], n.P = e.duration) : e.duration === n.P && e.startTime === n.entries[0].startTime && n.entries.push(e) : (n = {
          id: e.interactionId,
          entries: [e],
          P: e.duration
        }, this.l.set(n.id, n), this.u.push(n)), this.u.sort(function (e, t) {
          return t.P - e.P;
        }), this.u.length > 10) {
          var _e3 = this.u.splice(10);
          var _iterator5 = _createForOfIteratorHelper(_e3),
            _step5;
          try {
            for (_iterator5.s(); !(_step5 = _iterator5.n()).done;) {
              var _t5 = _step5.value;
              this.l.delete(_t5.id);
            }
          } catch (err) {
            _iterator5.e(err);
          } finally {
            _iterator5.f();
          }
        }
        (_this$p = this.p) === null || _this$p === void 0 || _this$p.call(this, n);
      }
    }
  }]);
  return k;
}();
var A = function A(e) {
    var t = globalThis.requestIdleCallback || setTimeout;
    "hidden" === document.visibilityState ? e() : (e = f(e), addEventListener("visibilitychange", e, {
      once: !0,
      capture: !0
    }), t(function () {
      e(), removeEventListener("visibilitychange", e, {
        capture: !0
      });
    }));
  },
  B = [200, 500],
  S = function S(e) {
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    if (!globalThis.PerformanceEventTiming || !("interactionId" in PerformanceEventTiming.prototype)) return;
    var s = v();
    g(function () {
      var _i$durationThreshold;
      I();
      var o,
        c = r("INP");
      var d = a(i, k),
        f = function f(e) {
          A(function () {
            var _iterator6 = _createForOfIteratorHelper(e),
              _step6;
            try {
              for (_iterator6.s(); !(_step6 = _iterator6.n()).done;) {
                var _t6 = _step6.value;
                d.h(_t6);
              }
            } catch (err) {
              _iterator6.e(err);
            } finally {
              _iterator6.f();
            }
            var t = d.L();
            t && t.P !== c.value && (c.value = t.P, c.entries = t.entries, o());
          });
        },
        u = h("event", f, {
          durationThreshold: (_i$durationThreshold = i.durationThreshold) !== null && _i$durationThreshold !== void 0 ? _i$durationThreshold : 40
        });
      o = n(e, c, B, i.reportAllChanges), u && (u.observe({
        type: "first-input",
        buffered: !0
      }), s.onHidden(function () {
        f(u.takeRecords()), o(!0);
      }), t(function () {
        d.v(), c = r("INP"), o = n(e, c, B, i.reportAllChanges);
      }));
    });
  };
var N = /*#__PURE__*/function () {
  function N() {
    _classCallCheck(this, N);
    this.m = void 0;
  }
  _createClass(N, [{
    key: "h",
    value: function h(e) {
      var _this$m2;
      (_this$m2 = this.m) === null || _this$m2 === void 0 || _this$m2.call(this, e);
    }
  }]);
  return N;
}();
var q = [2500, 4e3],
  x = function x(e) {
    var s = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    g(function () {
      var c = v();
      var d,
        u = r("LCP");
      var l = a(s, N),
        m = function m(e) {
          s.reportAllChanges || (e = e.slice(-1));
          var _iterator7 = _createForOfIteratorHelper(e),
            _step7;
          try {
            for (_iterator7.s(); !(_step7 = _iterator7.n()).done;) {
              var _t7 = _step7.value;
              l.h(_t7), _t7.startTime < c.firstHiddenTime && (u.value = Math.max(_t7.startTime - o(), 0), u.entries = [_t7], d());
            }
          } catch (err) {
            _iterator7.e(err);
          } finally {
            _iterator7.f();
          }
        },
        p = h("largest-contentful-paint", m);
      if (p) {
        d = n(e, u, q, s.reportAllChanges);
        var _o = f(function () {
            m(p.takeRecords()), p.disconnect(), d(!0);
          }),
          _c = function _c(e) {
            e.isTrusted && (A(_o), removeEventListener(e.type, _c, {
              capture: !0
            }));
          };
        for (var _i2 = 0, _arr = ["keydown", "click", "visibilitychange"]; _i2 < _arr.length; _i2++) {
          var _e4 = _arr[_i2];
          addEventListener(_e4, _c, {
            capture: !0
          });
        }
        t(function (t) {
          u = r("LCP"), d = n(e, u, q, s.reportAllChanges), i(function () {
            u.value = performance.now() - t.timeStamp, d(!0);
          });
        });
      }
    });
  },
  H = [800, 1800],
  O = function O(e) {
    document.prerendering ? g(function () {
      return O(e);
    }) : "complete" !== document.readyState ? addEventListener("load", function () {
      return O(e);
    }, !0) : setTimeout(e);
  },
  $ = function $(e) {
    var i = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var c = r("TTFB"),
      a = n(e, c, H, i.reportAllChanges);
    O(function () {
      var d = s();
      d && (c.value = Math.max(d.responseStart - o(), 0), c.entries = [d], a(!0), t(function () {
        c = r("TTFB", 0), a = n(e, c, H, i.reportAllChanges), a(!0);
      }));
    });
  };
export { b as CLSThresholds, y as FCPThresholds, B as INPThresholds, q as LCPThresholds, H as TTFBThresholds, L as onCLS, E as onFCP, S as onINP, x as onLCP, $ as onTTFB };